export default "__VITE_ASSET__DCBxfAyk__"